import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Head, Link, useForm } from '@inertiajs/react';
import React from 'react';
import { Logo } from './components/Logo';

export default function VerifyEmail() {
  const { data, setData, post, processing, errors } = useForm({
    email_address: '',
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    post('/email_verification');
  };

  return (
    <>
      <Head title="Resend Verification Email" />
      <div className="grid w-full h-full">
        <div className="flex flex-col items-center justify-center gap-3 px-6">
          <Logo />
          <h1 className="text-2xl font-bold text-center">
            Resend Verification Email
          </h1>
          <p className="mb-4 text-sm text-balance text-muted-foreground">
            Enter your email address and we'll send you a new verification link.
          </p>

          <form
            onSubmit={handleSubmit}
            className="flex flex-col w-full max-w-md gap-5 text-center"
          >
            <div className="flex flex-col gap-2">
              <Label htmlFor="email" className="mb-1">
                Email Address
              </Label>
              <Input
                type="email"
                id="email"
                placeholder="Eg., johndoe@project-short.com"
                value={data.email_address}
                onChange={(e) => setData('email_address', e.target.value)}
                required
                disabled={processing}
              />
              {errors.email_address && (
                <p className="mt-1 text-sm text-red-500">
                  {errors.email_address}
                </p>
              )}
            </div>
            <Button>
              {processing ? 'Sending...' : 'Resend Verification Email'}
            </Button>
          </form>
          <div className="text-sm text-center">
            <Link href="/session/new" className="underline underline-offset-4">
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
